/**
 * VendorRatingService
 * Service for managing vendor ratings with view endpoints
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor rating CRUD operations with view endpoints
 */
export class VendorRatingService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorRatingService.DEFAULT_SERVICE_PATH,
            basePath: VendorRatingService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all vendor rating views
     * @returns Array of vendor rating model views
     */
    async getViews() {
        const response = await this.getViewsRaw();
        return response.data ?? [];
    }
    /**
     * Get all vendor rating views with full response
     * @returns ResponseData with array of vendor rating model views
     */
    getViewsRaw() {
        const url = this.buildUrl('views');
        return this.http.get(url);
    }
    /**
     * Get filtered vendor rating list with pagination
     * @param filter - Optional filter parameters
     * @returns Paginated vendor rating list response
     */
    async listView(filter) {
        const response = await this.listViewRaw(filter);
        if (!response.data) {
            return {
                ratings: [],
                totalCount: 0,
                page: filter?.page ?? 1,
                pageSize: filter?.pageSize ?? 20,
                totalPages: 0,
                hasNextPage: false,
                hasPreviousPage: false,
                averageOverallRating: 0,
                averageQualityRating: 0,
                averageServiceRating: 0,
                averageValueRating: 0,
                verifiedPurchaseCount: 0,
                flaggedCount: 0,
                oneStarCount: 0,
                twoStarCount: 0,
                threeStarCount: 0,
                fourStarCount: 0,
                fiveStarCount: 0,
            };
        }
        return response.data;
    }
    /**
     * Get filtered vendor rating list with pagination and full response
     * @param filter - Optional filter parameters
     * @returns ResponseData with paginated vendor rating list
     */
    listViewRaw(filter) {
        const url = this.buildUrl('list-view');
        return this.http.post(url, filter);
    }
    /**
     * Get vendor rating view by ID
     * @param id - Rating ID
     * @returns Vendor rating model view
     */
    async getView(id) {
        const response = await this.getViewRaw(id);
        if (!response.data) {
            throw new Error(`Vendor rating view with ID ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get vendor rating view by ID with full response
     * @param id - Rating ID
     * @returns ResponseData with vendor rating model view
     */
    getViewRaw(id) {
        const url = this.buildUrl(`${id}/view`);
        return this.http.get(url);
    }
}
VendorRatingService.DEFAULT_SERVICE_PATH = 'vendor-ratings';
VendorRatingService.BASE_PATH = 'api/vendor-ratings';
//# sourceMappingURL=VendorRatingService.js.map